import { Button, Form, FormFieldSelectInput } from '@/shared/components';
import {
  type AccessTypeSelectOption,
  type AuthenticationTypeSelectOption,
  type EditApiTokenFormValues,
} from '../model';
import { useTranslation } from 'react-i18next';
import type { UseFormReturn } from 'react-hook-form';

const SELECT_CLASSNAME =
  'pr-[2rem] data-[state=open]:bg-stroke [&>svg]:text-secondary [&>svg]:stroke-[1.5]';

type Props = {
  form: UseFormReturn<EditApiTokenFormValues>;
  updateApiToken: () => Promise<void>;
  isPending: boolean;
  accessTypes: AccessTypeSelectOption[];
  authenticationTypes: AuthenticationTypeSelectOption[];
};

export const EditApiTokenForm = ({
  form,
  updateApiToken,
  isPending,
  accessTypes,
  authenticationTypes,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Form {...form}>
      <form
        className="flex flex-col gap-[1.6rem]"
        onSubmit={form.handleSubmit(updateApiToken)}>
        <FormFieldSelectInput<AuthenticationTypeSelectOption>
          name="authenticationType"
          label={t('webApiTokens.fieldLabels.authenticationType')}
          items={authenticationTypes}
          withChevron
          showOptionCheckmark={false}
          className={SELECT_CLASSNAME}
          renderItem={item => <div className="headline4">{item.label}</div>}
          renderSelectedValue={value => (
            <div className="p3">
              {authenticationTypes.find(type => type.value === value)?.label}
            </div>
          )}
        />

        <FormFieldSelectInput<AccessTypeSelectOption>
          name="access"
          label={t('webApiTokens.fieldLabels.accessRights')}
          items={accessTypes}
          withChevron
          showOptionCheckmark={false}
          className={SELECT_CLASSNAME}
          renderItem={item => <div className="headline4">{item.label}</div>}
          renderSelectedValue={value => (
            <div className="p3">
              {accessTypes.find(type => type.value === value)?.label}
            </div>
          )}
        />

        <Button
          size="lg"
          type="submit"
          loading={isPending}
          className="mt-[0.8rem] sm:mt-[1.6rem]">
          {t('webApiTokens.editing.submitButtonText')}
        </Button>
      </form>
    </Form>
  );
};
